<div class="d-flex flex-column justify-content-between wrapper">
  <div class="page-body">
    <app-header *ngIf="!isBusinessMobile"></app-header>
    <div
      class="scrollable-content"
      (touchstart)="onTouchStart($event)"
      (touchmove)="onTouchMove($event)"
      (touchend)="onTouchEnd($event)"
    >
      <app-loader *ngIf="(isLoading | async) || (isBusinessMobile && isNavigating)" />
      <div class="refresh"  [ngClass]="!isLanding() ? (isBusinessMobile ? 'my-container' : 'page-flex-my my-container') : ''">
        <app-sidebar *ngIf="this.authService.isLoggedIn && !isLanding() && isSidebarShow()"></app-sidebar>
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
  <app-footer *ngIf="!isMobile"></app-footer>
</div>
<app-debug-panel *ngIf="isDebugPanelAllowed"></app-debug-panel>
